export const sharedDatePickerOptions = {
    enableTime:true,
    inline:false,
    clickOpens:true,
    static:false,
    dateFormat:"Y-m-d H:i",
    time_24hr:true
}